<template>
  <section class="section">
    <div class="content has-text-centered">
      <h1 class="title is-1">403</h1>
      <p class="subtitle is-4" v-t="'subtitle'" />
      <p v-html="$t('description')" />
      <router-link :to="{ name: 'home' }" class="button is-primary">
        <b-icon icon="home" size="is-small" />
        <span v-t="'home_link'" />
      </router-link>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ForbiddenError',
  metaInfo () {
    return { title: this.$t('subtitle') }
  }
}
</script>

<i18n>
{
  "en-US": {
    "subtitle": "Page not found",
    "description": "Our website doesn't have a page that matches the requested address.<br>How about starting looking for the correct page from the home?",
    "home_link": "Home"
  },
  "pt-BR": {
    "subtitle": "Acesso negado",
    "description": "Você não possui acesso a esta página. Por favor, retorne à homepage.",
    "home_link": "Home"
  }
}
</i18n>
